import React from "react";

const ChannelHeader = ({ channel, user }) => {
  const otherUser =
    (channel.members && channel.members.find((u) => u.userId != user.userId)) ||
    {};
  return (
    <div className="sendbird-chat-header">
      <div className="sendbird-chat-header__left">
        <div
          className="sendbird-chat-header__avatar sendbird-avatar"
          style={{ height: "32px", width: "32px" }}
        >
          <div className="sendbird-image-renderer ">
            <img
              style={{
                height: "32px",
                width: "32px",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "cover"
              }}
              src={otherUser.profileUrl}
              className="sendbird-avatar-img"
            />
          </div>
        </div>
        <div className="sendbird-label sendbird-chat-header__title sendbird-label--h-2 sendbird-label--color-onbackground-1">
          {otherUser.nickname}
        </div>
        <div className="sendbird-label sendbird-chat-header__subtitle sendbird-label--body-1 sendbird-label--color-onbackground-2">
          <div className="sendbird-repeat-text"></div>
        </div>
      </div>
    </div>
  );
};

export default ChannelHeader;
